import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sprout, Wrench, Building2, GraduationCap } from 'lucide-react';

const getAudiences = (t: (key: string) => string) => [
  {
    id: 'agriculteur',
    labelKey: 'audiences.farmers',
    icon: Sprout,
    link: '/agriculteurs',
    color: 'blue', // Wiki Agri Tech blue
  },
  {
    id: 'technicien',
    labelKey: 'audiences.technicians',
    icon: Wrench,
    link: '/techniciens',
    color: 'orange', // WAT orange #EA580C
  },
  {
    id: 'decideur',
    labelKey: 'audiences.decisionMakers',
    icon: Building2,
    link: '/decideur',
    color: 'green', // Aspexit green
  },
  {
    id: 'chercheur',
    labelKey: 'audiences.researchers',
    icon: GraduationCap,
    link: '/chercheurs',
    color: 'purple', // WAT purple
  },
];

const colorClasses = {
  red: 'bg-white text-aspexit-gray hover:bg-aspexit-red/10 hover:text-aspexit-red border-border hover:border-aspexit-red/20',
  orange: 'bg-white text-aspexit-gray hover:bg-[#EA580C]/10 hover:text-[#EA580C] border-border hover:border-[#EA580C]/20',
  green: 'bg-white text-aspexit-gray hover:bg-aspexit-green/10 hover:text-aspexit-green border-border hover:border-aspexit-green/20',
  purple: 'bg-white text-aspexit-gray hover:bg-[#D8B4FE]/10 hover:text-[#D8B4FE] border-border hover:border-[#D8B4FE]/20',
  blue: 'bg-white text-aspexit-gray hover:bg-[#0066CC]/10 hover:text-[#0066CC] border-border hover:border-[#0066CC]/20',
};

export function AudienceTags() {
  const { t, i18n } = useTranslation('home');
  const { locale } = useParams<{ locale: string }>();
  const currentLocale = locale || i18n.language || 'fr';
  const audiences = getAudiences(t);

  return (
    <div>
      <div className="flex flex-wrap gap-2 md:gap-3">
        {audiences.map((audience) => {
          const Icon = audience.icon;
          return (
            <Link
              key={audience.id}
              to={`/${currentLocale}${audience.link}`}
              className={`
                inline-flex items-center gap-1.5 px-3 md:px-4 py-1.5 md:py-2
                rounded-full border-2 font-medium text-xs md:text-sm
                transition-all duration-300 hover:scale-105 hover:shadow-lg
                ${colorClasses[audience.color as keyof typeof colorClasses]}
              `}
            >
              <Icon className="w-3.5 h-3.5 md:w-4 md:h-4" />
              <span>{t(audience.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
